export const sheetSelector = (state) => state.sheet.sheet;
export const resourcesSelector = (state) => state.sheet.resources;
export const isLoadingSelector = (state) => state.sheet.loading;
